import { useCallback, useEffect, useRef, useState } from 'react'
import { getGeocode, getLatLng } from 'use-places-autocomplete'

import HospitalIconSrc from '@/assets/img/hopital.png'

import GoogleMap, { GoogleMapHandle } from '@/components/ui/map/GoogleMap'

function iconGenerator(url: string) {
  return {
    anchor: new google.maps.Point(30 / 2, 30 / 2),
    origin: new google.maps.Point(0, 0),
    scaledSize: new google.maps.Size(30, 30),
    size: new google.maps.Size(30, 30),
    url,
  }
}

export type MapProps = {
  home?: string
  places: string[] // list of placeId
}

export function Map(props: MapProps) {
  const { home, places } = props

  const prevHome = useRef<string>()
  const googleMapRef = useRef<GoogleMapHandle>(null)

  const [loaded, setLoaded] = useState(false)

  const handleLoad = useCallback(() => {
    setLoaded(true)
  }, [])

  useEffect(() => {
    if (!loaded) return

    if (!!prevHome.current) googleMapRef.current?.removeMarker(prevHome.current)

    if (home) {
      getGeocode({ placeId: home })
        .then((results) => getLatLng(results[0]))
        .then(({ lat, lng }) => {
          if (!googleMapRef.current) return

          const marker = googleMapRef.current.createMarker(lat, lng, iconGenerator(HospitalIconSrc))
          googleMapRef.current.addMarker(home, marker)
        })
        .catch(console.error)
    }

    prevHome.current = home
  }, [loaded, home])

  useEffect(() => {
    if (!loaded || !places.length) return

    for (const placeId of places) {
      getGeocode({ placeId })
        .then((results) => getLatLng(results[0]))
        .then(({ lat, lng }) => {
          if (!googleMapRef.current) return

          const marker = googleMapRef.current.createMarker(lat, lng, iconGenerator(HospitalIconSrc))
          googleMapRef.current.addMarker(placeId, marker)
        })
        .catch(console.error)
    }
  }, [loaded, places])

  return <GoogleMap onLoad={handleLoad} ref={googleMapRef} />
}

export default Map
